module.exports = __webpack_public_path__ + "img/bgr.3d762564.svg";